import React, { useContext } from 'react';
import AuthCardLayout from './authentication/AuthCardLayout';
import ForgetPasswordForm from './authentication/ForgetPasswordForm';
import { CiatAppContext } from '../../providers';

function ChangePassword() {
  const { currentUser } = useContext(CiatAppContext);
  const profile = currentUser ? currentUser.profile : {};
  const currentUserEmail = profile ? profile.user.email : '';
  return (
    <AuthCardLayout>
      <h4 className="mb-0"> Змінити свій пароль</h4>
      <p />
      <p className="mb-0">Введіть свою електронну адресу, і ми надішлемо вам посилання для нового паролю.</p>
      <ForgetPasswordForm layout="card" currentUserEmail={currentUserEmail} />
    </AuthCardLayout>
  );
}

export default ChangePassword;
